import {FolderType} from '../../types';

export const migrationKey = 'afanassii25662';
// export const migrationKey = 'p2';
export const dbID = migrationKey;
export const userDocKey = 'userDoc';
export const domain = 'https://www.starpy.me/';
export const cdndomain = 'https://cdn.starpy.me/';
export const contactPrefix = 'contact_';
export const publicPartyPref = 'public_party_';
export const ffMpegWasmBaseUrl =
  'https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd';
export const appDirectory = 'starp';

export const encoderProjectTypes = [
  FolderType.encoder,
  FolderType.editor,
];
export const googleDocumentKey = 'google_document';
export const defaultFolders = [
  'demo',
  'new',
  'nearby',
  publicPartyPref,
  'tutorial',
  'new_editor',
  'new_media',
  'new_chat',
  'new_encoder',
];
export const loaderURI =
  'https://raw.githubusercontent.com/AboutReact/sampleresource/master/old_logo.png';

export const MEDIA = [
  {
    id: 'sintel',
    title: 'Sintel',
    thumbnail: 'https://starpy.me/webapp/sintel.jpg',
    folderId: 'demo',
    extractor: 'wt',
    url: 'magnet:?xt=urn:btih:08ada5a7a6183aae1e09d831df6748d566095a10&dn=Sintel&tr=udp%3A%2F%2Fexplodie.org%3A6969&tr=udp%3A%2F%2Ftracker.coppersurfer.tk%3A6969&tr=udp%3A%2F%2Ftracker.empire-js.us%3A1337&tr=udp%3A%2F%2Ftracker.leechers-paradise.org%3A6969&tr=udp%3A%2F%2Ftracker.opentrackr.org%3A1337&tr=wss%3A%2F%2Ftracker.btorrent.xyz&tr=wss%3A%2F%2Ftracker.fastcast.nz&tr=wss%3A%2F%2Ftracker.openwebtorrent.com&ws=https%3A%2F%2Fwebtorrent.io%2Ftorrents%2F&xs=https%3A%2F%2Fwebtorrent.io%2Ftorrents%2Fsintel.torrent',
  },
  {
    id: 'tears',
    title: 'Tears of Steel',
    thumbnail: 'https://starpy.me/webapp/tearsOfSteel.jpg',
    folderId: 'demo',
    extractor: 'wt',
    url: 'magnet:?xt=urn:btih:209c8226b299b308beaf2b9cd3fb49212dbd13ec&dn=Tears+of+Steel&tr=udp%3A%2F%2Fexplodie.org%3A6969&tr=udp%3A%2F%2Ftracker.coppersurfer.tk%3A6969&tr=udp%3A%2F%2Ftracker.empire-js.us%3A1337&tr=udp%3A%2F%2Ftracker.leechers-paradise.org%3A6969&tr=udp%3A%2F%2Ftracker.opentrackr.org%3A1337&tr=wss%3A%2F%2Ftracker.btorrent.xyz&tr=wss%3A%2F%2Ftracker.fastcast.nz&tr=wss%3A%2F%2Ftracker.openwebtorrent.com&ws=https%3A%2F%2Fwebtorrent.io%2Ftorrents%2F&xs=https%3A%2F%2Fwebtorrent.io%2Ftorrents%2Ftears-of-steel.torrent',
  },
  {
    id: 'cosmoslaundromat',
    title: 'Cosmos Laundromat',
    thumbnail: 'https://starpy.me/webapp/cosmosLaundromat.jpg',
    folderId: 'demo',
    extractor: 'wt',
    url: 'magnet:?xt=urn:btih:c9e15763f722f23e98a29decdfae341b98d53056&dn=Cosmos+Laundromat&tr=udp%3A%2F%2Fexplodie.org%3A6969&tr=udp%3A%2F%2Ftracker.coppersurfer.tk%3A6969&tr=udp%3A%2F%2Ftracker.empire-js.us%3A1337&tr=udp%3A%2F%2Ftracker.leechers-paradise.org%3A6969&tr=udp%3A%2F%2Ftracker.opentrackr.org%3A1337&tr=wss%3A%2F%2Ftracker.btorrent.xyz&tr=wss%3A%2F%2Ftracker.fastcast.nz&tr=wss%3A%2F%2Ftracker.openwebtorrent.com&ws=https%3A%2F%2Fwebtorrent.io%2Ftorrents%2F&xs=https%3A%2F%2Fwebtorrent.io%2Ftorrents%2Fcosmos-laundromat.torrent',
  },
  {
    id: 'bbb',
    title: 'Big Buck Bunny',
    thumbnail: 'https://starpy.me/webapp/bigBuckBunny.jpg',
    folderId: 'demo',
    extractor: 'wt',
    url: 'magnet:?xt=urn:btih:dd8255ecdc7ca55fb0bbf81323d87062db1f6d1c&dn=Big+Buck+Bunny&tr=udp%3A%2F%2Fexplodie.org%3A6969&tr=udp%3A%2F%2Ftracker.coppersurfer.tk%3A6969&tr=udp%3A%2F%2Ftracker.empire-js.us%3A1337&tr=udp%3A%2F%2Ftracker.leechers-paradise.org%3A6969&tr=udp%3A%2F%2Ftracker.opentrackr.org%3A1337&tr=wss%3A%2F%2Ftracker.btorrent.xyz&tr=wss%3A%2F%2Ftracker.fastcast.nz&tr=wss%3A%2F%2Ftracker.openwebtorrent.com&ws=https%3A%2F%2Fwebtorrent.io%2Ftorrents%2F&xs=https%3A%2F%2Fwebtorrent.io%2Ftorrents%2Fbig-buck-bunny.torrent',
  },
];

const FOLDERS = [
  {
    id: 'wired',
    title: 'The WIRED CD - Rip. Sample. Mash. Share',
    posterFileName: 'wiredCd.jpg',
    torrentFileName: 'wiredCd.torrent',
  },
];

export const colors = {
  textColor: 'white',
  backgroundColor: 'black',
  mediaItemTextColor: 'palegoldenrod',
  mediaBackgroundColor: '#2b2b2b',
  mediaBorderColor: 'black',
  navTextColor: '#e1d76a',
  navInactiveColor: '#585858',
  folderColor: '#585858',
  folderTextColor: 'black',
  deleteBackgroundColor: 'red',
  deleteTextColor: 'black',
  navBorderColor: '#585858',
  contactItemBackgroundColor: '#2b2b2b',
  contactItemTitleColor: '#e1d76a',
  contactItemOnlineColor: 'green',
  theme: 'dark',
  currentUserColor: '#585858',
  remoteUserColor: 'cornflowerblue',
};
